
import './../styles/home.css';
import { Helmet } from "react-helmet";


const  Home = () => {
    return (
   <>
    <Helmet>
        <title>Kochetkov Studio</title>
        <meta name="description" content="Студия Кочеткова: digital-решения под ключ. От сайтов до ботов – всё для роста вашего бизнеса! Заказать сайт, бота, мобильное приложение."/>
    </Helmet>

     <div className="app">
        <div className="home">
        <p className="text-home">
        🚀 Цифровые продукты, которые работают на ваш бизнес 24/7
        <br/><br/>
        Вашему бизнесу нужен продающий сайт, удобное мобильное приложение или умный чат-бот? 
        Мы создаем цифровые решения, которые привлекают клиентов, автоматизируют продажи и увеличивают прибыль.
        <br/>
        <br/>
        🔥 Почему выбирают нас?
        <br/><br/>
        ✔ Полный цикл разработки — от идеи до запуска и поддержки.
        <br/>
        ✔ Продающий дизайн — стильно, удобно и функционально.
        <br/>
        ✔ SEO и маркетинг — ваш продукт будет находить клиентов.
        <br/>
        ✔ Технологии будущего — AI, боты, автоматизация.
        <br/>
        ✔ Поддержка 24/7 — ваш бизнес в надежных руках.
        <br/><br/>
        💡 Хотите сайт, приложение или бота, который приносит прибыль?
        <br/>  <br/>
        📩 Оставьте заявку сегодня и получите бесплатную консультацию + спецпредложение!
        <br/> <br/>
        Ваш успех начинается с правильного digital-решения! 🚀</p>
     </div> 
    </div>
   </>

    )
}

export default Home;